<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div *ngIf="success || error" tamsyMargin marginY="10px">
  <esl-message-toast
    [(message)]="success"
    [duration]="10000"
    [messageType]="'success'"
  ></esl-message-toast>
  <esl-message-toast [(message)]="error"></esl-message-toast>
</div>
<div
  class="confirm_company"
  *ngIf="formOneEnabled && confirmedName && cacRecord && !proceedToNextStage"
>
  <p>
    Is this your Company Name? <span>{{ cacRecord.companyName }}</span>
  </p>
  <div class="grouped fields">
    <div class="field">
      <div>
        <sui-radio-button name="entity" value="yes" [(ngModel)]="eRadio"
          ><strong>Yes</strong>
        </sui-radio-button>
      </div>
    </div>
    <div class="field" appMargin marginT="5">
      <sui-radio-button name="entity" value="no" [(ngModel)]="eRadio"
        ><strong>No </strong>
      </sui-radio-button>
    </div>
  </div>
</div>
<p
  class="warning-label"
  *ngIf="formOneEnabled && confirmedName && proceedToNextStage === 'no'"
>
  Enter the correct company detail and try again by clicking the ‘Retry’ button.
</p>
<div class="contents">
  <div
    class="scroll-wrapper ui basic segment"
    [ngClass]="{ loading: pending }"
    style="padding: 0"
  >
    <div class="ui form" [formGroup]="companyForm">
      <div class="form_one" *ngIf="formOneEnabled">
        <div class="section">
          <h2
            style="
              font-style: normal;
              font-weight: 600;
              font-size: 14px;
              line-height: 16px;
              color: #3f4395;
            "
          >
            Company Ownership Type
          </h2>
          <div
            class="required field"
            [ngClass]="displayFieldCss('ownershipType')"
            appMargin
            marginT="5"
          >
            <label>Company Ownership Type</label>
            <sui-select
              class="selection"
              [options]="ownershipType"
              valueField="optionId"
              labelField="optionName"
              isSearchable="true"
              formControlName="ownershipType"
              placeholder="Select Ownership Type"
              [isDisabled]="isDisabled"
              #selectsy
            >
              <sui-select-option
                *ngFor="let option of selectsy.filteredOptions"
                [value]="option"
              >
              </sui-select-option>
            </sui-select>
            <app-field-error-display
              [displayError]="isFieldValid('ownershipType')"
              errorMsg="Please select Ownership Type"
            >
            </app-field-error-display>
          </div>
        </div>
        <div class="section">
          <h2
            style="
              font-style: normal;
              font-weight: 600;
              font-size: 14px;
              line-height: 16px;
              color: #3f4395;
            "
          >
            Company Type
          </h2>
          <div
            class="required field"
            [ngClass]="displayFieldCss('companyTypeId')"
            appMargin
            marginT="5"
          >
            <label>Company Type</label>
            <sui-select
              class="selection"
              [options]="companyType"
              valueField="optionId"
              labelField="optionName"
              isSearchable="true"
              formControlName="companyTypeId"
              placeholder="Select company type"
              [isDisabled]="
                formOneEnabled &&
                confirmedName &&
                cacRecord &&
                !proceedToNextStage
              "
              #selectsyu
            >
              <sui-select-option
                *ngFor="let option of selectsyu.filteredOptions"
                [value]="option"
              >
              </sui-select-option>
            </sui-select>
            <app-field-error-display
              [displayError]="isFieldValid('companyTypeId')"
              errorMsg="Please select company type"
            >
            </app-field-error-display>
          </div>
        </div>
        <div class="section">
          <h2
            style="
              font-style: normal;
              font-weight: 600;
              font-size: 14px;
              line-height: 16px;
              color: #3f4395;
            "
          >
            RC Number
          </h2>
          <div class="required field" [ngClass]="displayFieldCss('rcNumber')">
            <label>RC Number</label>
            <input
              *ngIf="
                formOneEnabled &&
                confirmedName &&
                cacRecord &&
                !proceedToNextStage
              "
              formControlName="rcNumber"
              type="text"
              disabled
              placeholder="Enter RC Number"
            />
            <input
              *ngIf="
                (formOneEnabled && !confirmedName && !cacRecord) ||
                proceedToNextStage === 'no'
              "
              formControlName="rcNumber"
              type="text"
              placeholder="Enter RC Number"
            />
            <app-field-error-display
              [displayError]="isFieldValid('rcNumber')"
              errorMsg="Please enter RC Number"
            >
            </app-field-error-display>
          </div>
        </div>
        <div class="section">
          <h2
            style="
              font-style: normal;
              font-weight: 600;
              font-size: 14px;
              line-height: 16px;
              color: #3f4395;
            "
          >
            Company Tax Identification Number
          </h2>
          <div class="field" [ngClass]="displayFieldCss('tin')">
            <label>Company Tax Identification Number</label>
            <input
              *ngIf="
                formOneEnabled &&
                confirmedName &&
                cacRecord &&
                !proceedToNextStage
              "
              formControlName="tin"
              type="text"
              disabled
              placeholder="Enter company tax identification number"
            />
            <input
              *ngIf="
                (formOneEnabled && !confirmedName && !cacRecord) ||
                proceedToNextStage === 'no'
              "
              formControlName="tin"
              type="text"
              placeholder="Enter company tax identification number"
            />

            <app-field-error-display
              [displayError]="isFieldValid('tin')"
              errorMsg="Please enter company tax identification number"
            >
            </app-field-error-display>
          </div>
        </div>
      </div>
    </div>
    <div class="ui form" [formGroup]="companySecondForm">
      <div class="form_two" *ngIf="formTwoEnabled">
        <div class="section">
          <h2
            style="
              font-style: normal;
              font-weight: 600;
              font-size: 14px;
              line-height: 16px;
              color: #3f4395;
            "
          >
            Company Name
          </h2>
          <div
            class="required field"
            [ngClass]="displaySecondFieldCss('companyName')"
            appMargin
            marginT="5"
          >
            <label>Company Name</label>
            <input
              formControlName="companyName"
              type="text"
              disabled
              placeholder="Enter Company Name"
            />
            <app-field-error-display
              [displayError]="isFieldSecondValid('companyName')"
              errorMsg="Please select Company Name"
            >
            </app-field-error-display>
          </div>
        </div>
        <div class="section">
          <h2
            style="
              font-style: normal;
              font-weight: 600;
              font-size: 14px;
              line-height: 16px;
              color: #3f4395;
            "
          >
            Company Ownership Type
          </h2>
          <div
            class="required field"
            [ngClass]="displaySecondFieldCss('ownershipType')"
            appMargin
            marginT="5"
          >
            <label>Company Ownership Type</label>
            <sui-select
              class="selection"
              [options]="ownershipType"
              valueField="optionId"
              labelField="optionName"
              isSearchable="true"
              formControlName="ownershipType"
              placeholder="Select Ownership Type"
              [isDisabled]="isDisabled"
              #selectsy
            >
              <sui-select-option
                *ngFor="let option of selectsy.filteredOptions"
                [value]="option"
              >
              </sui-select-option>
            </sui-select>
            <app-field-error-display
              [displayError]="isFieldSecondValid('ownershipType')"
              errorMsg="Please select Ownership Type"
            >
            </app-field-error-display>
          </div>
        </div>
        <div class="section">
          <h2
            style="
              font-style: normal;
              font-weight: 600;
              font-size: 14px;
              line-height: 16px;
              color: #3f4395;
            "
          >
            Company Type
          </h2>
          <div
            class="required field"
            [ngClass]="displaySecondFieldCss('companyTypeId')"
            appMargin
            marginT="5"
          >
            <label>Company Type</label>
            <sui-select
              class="selection"
              [options]="companyType"
              valueField="optionId"
              labelField="optionName"
              isSearchable="true"
              formControlName="companyTypeId"
              placeholder="Select company type"
              [isDisabled]="isDisabled"
              #selectsyu
            >
              <sui-select-option
                *ngFor="let option of selectsyu.filteredOptions"
                [value]="option"
              >
              </sui-select-option>
            </sui-select>
            <app-field-error-display
              [displayError]="isFieldSecondValid('companyTypeId')"
              errorMsg="Please select company type"
            >
            </app-field-error-display>
          </div>
        </div>
        <div class="section">
          <h2
            style="
              font-style: normal;
              font-weight: 600;
              font-size: 14px;
              line-height: 16px;
              color: #3f4395;
            "
          >
            RC Number
          </h2>
          <div
            class="required field"
            [ngClass]="displaySecondFieldCss('rcNumber')"
          >
            <label>RC Number</label>
            <input
              formControlName="rcNumber"
              type="text"
              disabled
              placeholder="Enter RC Number"
            />
            <app-field-error-display
              [displayError]="isFieldSecondValid('rcNumber')"
              errorMsg="Please enter RC Number"
            >
            </app-field-error-display>
          </div>
        </div>
        <div class="section">
          <h2
            style="
              font-style: normal;
              font-weight: 600;
              font-size: 14px;
              line-height: 16px;
              color: #3f4395;
            "
          >
            Company Tax Identification Number
          </h2>
          <div class="field" [ngClass]="displaySecondFieldCss('tin')">
            <label>Company Tax Identification Number</label>
            <input
              formControlName="tin"
              type="text"
              disabled
              placeholder="Enter company tax identification number"
            />
            <app-field-error-display
              [displayError]="isFieldSecondValid('tin')"
              errorMsg="Please enter company tax identification number"
            >
            </app-field-error-display>
          </div>
        </div>
        <div class="section">
          <h2
            style="
              font-style: normal;
              font-weight: 600;
              font-size: 14px;
              line-height: 16px;
              color: #3f4395;
            "
          >
            Address
          </h2>
          <div class="ui divider"></div>
          <div
            class="required field"
            [ngClass]="displaySecondFieldCss('headOfficeAddressStreet')"
          >
            <label>Street</label>
            <input
              formControlName="headOfficeAddressStreet"
              type="text"
              placeholder=""
            />
            <app-field-error-display
              [displayError]="isFieldSecondValid('headOfficeAddressStreet')"
              errorMsg="Please enter company address street"
            >
            </app-field-error-display>
          </div>
          <div
            class="required field"
            [ngClass]="displaySecondFieldCss('headOfficeAddressCity')"
          >
            <label>Area/City</label>
            <input formControlName="headOfficeAddressCity" type="text" />
            <app-field-error-display
              [displayError]="isFieldSecondValid('headOfficeAddressCity')"
              errorMsg="Please enter city"
            >
            </app-field-error-display>
          </div>

          <div
            class="required field"
            [ngClass]="displaySecondFieldCss('headOfficeAddressState')"
          >
            <label>State </label>
            <select
              class="myButton"
              placeholder="Select State"
              type="text"
              formControlName="headOfficeAddressState"
            >
              <option *ngFor="let opt of states" [ngValue]="opt">
                {{ opt.stateName }}
              </option>
            </select>
            <app-field-error-display
              [displayError]="isFieldSecondValid('headOfficeAddressState')"
              errorMsg="Please select state "
            >
            </app-field-error-display>
          </div>

          <div
            class="field"
            [ngClass]="displaySecondFieldCss('headOfficeAddressZip')"
          >
            <label>Zip code</label>
            <input formControlName="headOfficeAddressZip" type="text" />
            <app-field-error-display
              [displayError]="isFieldSecondValid('headOfficeAddressZip')"
              errorMsg="Please enter zip code"
            >
            </app-field-error-display>
          </div>
          <div
            class="required field"
            [ngClass]="displaySecondFieldCss('countryOfRegistration')"
          >
            <label>Country</label>
            <select
              class="myButton"
              placeholder="Select Country"
              formControlName="countryOfRegistration"
            >
              <option *ngFor="let opt of countries" [value]="opt">
                {{ opt.countryName }}
              </option>
            </select>
          </div>
        </div>

        <div class="section">
          <h2
            style="
              font-style: normal;
              font-weight: 600;
              font-size: 14px;
              line-height: 16px;
              color: #3f4395;
            "
          >
            Company Contact Information
          </h2>
          <div class="ui divider"></div>
          <div
            class="required field"
            [ngClass]="displaySecondFieldCss('companyContactEmail')"
          >
            <label>Email Address</label>
            <input
              formControlName="companyContactEmail"
              type="text"
              placeholder="Enter company email"
            />
            <app-field-error-display
              [displayError]="isFieldSecondValid('companyContactEmail')"
              errorMsg="Please enter company email address"
            >
            </app-field-error-display>
          </div>
          <div
            class="field"
            [ngClass]="displaySecondFieldCss('companyContactAlternativeEmail')"
          >
            <label>Alternative Email Address</label>
            <input
              formControlName="companyContactAlternativeEmail"
              type="text"
              placeholder="Enter company alternative email"
            />
            <app-field-error-display
              [displayError]="
                isFieldSecondValid('companyContactAlternativeEmail')
              "
              errorMsg="Please enter company alternative email address"
            >
            </app-field-error-display>
          </div>

          <div
            class="required field"
            [ngClass]="displaySecondFieldCss('phoneNumber')"
          >
            <label>Phone Number</label>
            <input formControlName="phoneNumber" type="text" />
            <app-field-error-display
              [displayError]="isFieldSecondValid('phoneNumber')"
              errorMsg="Please enter company phone"
            >
            </app-field-error-display>
          </div>
        </div>
        <div class="section">
          <h2
            style="
              font-style: normal;
              font-weight: 600;
              font-size: 14px;
              line-height: 16px;
              color: #3f4395;
            "
          >
            Role
          </h2>
          <div
            class="required field"
            [ngClass]="displaySecondFieldCss('roleId')"
            appMargin
            marginT="5"
          >
            <label>Role</label>
            <sui-select
              class="selection"
              [options]="roles"
              valueField="roleId"
              labelField="roleName"
              isSearchable="true"
              formControlName="roleId"
              [isDisabled]="isDisabled"
              placeholder="Search to select role"
              #multiSelectsy
            >
              <sui-select-option
                *ngFor="let option of multiSelectsy.filteredOptions"
                [value]="option"
              >
              </sui-select-option>
            </sui-select>
            <app-field-error-display
              [displayError]="isFieldSecondValid('roleId')"
              errorMsg="Please select role"
            >
            </app-field-error-display>
          </div>
        </div>
        <div class="section">
          <h2
            style="
              font-style: normal;
              font-weight: 600;
              font-size: 14px;
              line-height: 16px;
              color: #3f4395;
            "
          >
            Applications
          </h2>
          <div
            class="required field"
            [ngClass]="displaySecondFieldCss('applicationId')"
            appMargin
            marginT="5"
          >
            <label>Application</label>
            <sui-select
              class="selection"
              [options]="applications"
              valueField="applicationId"
              labelField="applicationName"
              isSearchable="true"
              formControlName="applicationId"
              placeholder="Select Application"
              #selectsynew
            >
              <sui-select-option
                *ngFor="let option of selectsynew.filteredOptions"
                [value]="option"
              >
              </sui-select-option>
            </sui-select>
            <app-field-error-display
              [displayError]="isFieldSecondValid('applicationId')"
              errorMsg="Please select application"
            >
            </app-field-error-display>
          </div>
        </div>

        <div class="section">
          <h2
            style="
              font-style: normal;
              font-weight: 600;
              font-size: 14px;
              line-height: 16px;
              color: #3f4395;
            "
          >
            Email for Invitation Link
          </h2>
          <div class="ui divider"></div>
          <div
            class="required field"
            [ngClass]="displaySecondFieldCss('appUserEmail')"
          >
            <label>Email Address</label>
            <input
              formControlName="appUserEmail"
              type="text"
              placeholder="Enter email for invitation"
            />
            <app-field-error-display
              [displayError]="isFieldSecondValid('appUserEmail')"
              errorMsg="Please enter email for invitation"
            >
            </app-field-error-display>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="actions">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Cancel
  </button>
  <button
    *ngIf="formTwoEnabled"
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    [disabled]="!companyForm.valid || pending"
    (click)="submit()"
    autofocus
  >
    Save
  </button>
  <button
    *ngIf="formOneEnabled && !confirmedName"
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    [disabled]="!companyForm.valid || pending"
    (click)="submitCompanyName()"
    autofocus
  >
    Proceed
  </button>
  <button
    *ngIf="formOneEnabled && confirmedName && cacRecord && !proceedToNextStage"
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    [disabled]="!eRadio || pending"
    (click)="confirmName()"
    autofocus
  >
    Proceed
  </button>
  <button
    *ngIf="formOneEnabled && confirmedName && proceedToNextStage === 'no'"
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    [disabled]="!companyForm.valid || pending"
    (click)="submitCompanyName()"
    autofocus
  >
    Retry
  </button>
</div>
